module.exports = __webpack_public_path__ + "static/media/hm3.4d3b3a4b.PNG";